import { openDB, DBSchema } from "idb";

interface BasicDataDB extends DBSchema {
  BasicData: {
    key: string;
    value: {
      id: string
      lastUpdate: string
      data: string
    };
  };
}

const dbPromise = openDB<BasicDataDB>("BasicData", 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("BasicData")) {
      db.createObjectStore("BasicData", { keyPath: "id", autoIncrement: false });
    }
  },
});

export async function addBasicData(id: string, data: string) {
  const db = await dbPromise;
  await db.add("BasicData", { id, lastUpdate: String(new Date()), data });
}

export async function getAllBasicData() {
  const db = await dbPromise;
  return await db.getAll("BasicData");
}

export async function getBasicDataById(id: string) {
  const db = await dbPromise;
  return await db.get("BasicData", id);
}

export async function deleteBasicData(id: string) {
  const db = await dbPromise;
  await db.delete("BasicData", id);
}

export async function deleteAllBasicData() {
  const db = await dbPromise;
  await db.clear("BasicData");
}